import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-common-sourcing-view',
  templateUrl: './common-sourcing-view.component.html',
  styleUrls: ['./common-sourcing-view.component.scss'],
  standalone: false
})
export class CommonSourcingViewComponent implements OnChanges {
  private _data: any;
  @Input()
  set data(value: any) {
    this._data = value;
  }
  get data(): any {
    return this._data;
  }
  private _config: { key: string; label: string; type?: 'text' | 'array' | 'boolean' | 'group-array'; fullWidth?: boolean; conditional?: boolean; legacy?: boolean; groupFields?: { key: string; label: string }[] }[] = [];
  @Input()
  set config(value: { key: string; label: string; type?: 'text' | 'array' | 'boolean' | 'group-array'; fullWidth?: boolean; conditional?: boolean; legacy?: boolean; groupFields?: { key: string; label: string }[] }[]) {
    this._config = value;

    const singleKeys = ['furniture_details', 'experience_type_details'];
    const singleKeyTypes = ['text', 'array'];

    if (this._config.length == 1) {
      this.config.map((field) => {
        // Removed the strict label check so it applies to both keys
        if (singleKeyTypes.includes(field.type || '') && singleKeys.includes(field.key)) {
          field.fullWidth = true;
        } else {
          field.fullWidth = false;
        }
      });
    }
   
  }
  get config() {
    return this._config;
  }
  @Input() title: string = '';
  @Input() readOnly: boolean = false;
  @Input() image?: string;
  @Input() emoji?: string;
  @Input() isOverview: boolean = false;
  
  @Output() onEdit = new EventEmitter<void>();
  @Output() onDelete = new EventEmitter<void>();

  isModalVisible = false;
  modalTitle = '';
  modalContent = '';

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.readOnly && changes['data']) {
      
    }
  }

  isLightingNoteInConfig(): boolean {
    return this._config.some(field => field.key === 'lighting_requirements_note');
  }

  isSingleItemConfig(): boolean {
    return this._config.length === 1;
  }

  get isVenueOverview(): boolean {
    return this.isOverview && this.title === 'Venue';
  }

  // Fields NOT marked legacy render in the main grid.
  get mainConfig() {
    return this._config.filter(field => !field.legacy);
  }

  // Legacy fields render in their own separate, visually distinct section.
  get legacyConfig() {
    return this._config.filter(field => field.legacy);
  }

  getFormattedValue(item: any, field: any): string {
    if (!item || !field) return '-';
    
    // Handle nested object paths (e.g., 'experience_type_details.name')
    let value = item;
    const keys = field.key.split('.');
    for (const key of keys) {
      if (value && typeof value === 'object') {
        value = value[key];
      } else {
        value = undefined;
        break;
      }
    }
    
    if (value === null || value === undefined || value === '') return '-';

    if (field.type === 'array' && Array.isArray(value)) {
      // Assuming array of objects with 'name' property or array of strings
      if (value.length === 0) return '-';
      if (typeof value[0] === 'object' && value[0].name) {
        return value.map((v: any) => v.name).join(', ');
      }
      return value.join(', ');
    }

    if (field.type === 'boolean') {
      return value ? 'Yes' : 'No';
    }

    return String(value);
  }

  shouldShowField(item: any, field: any): boolean {
    // group-array fields render their own block, not the standard label/value pair
    if (field.type === 'group-array') {
      return false;
    }
    // If field is marked as conditional, check if value exists
    if (field.conditional) {
      const value = this.getFormattedValue(item, field);
      return value !== '-';
    }
    return true;
  }

  // Returns the list of grouped items (e.g. venue_rooms_details) for a group-array field
  getGroupItems(item: any, field: any): any[] {
    const value = item ? item[field.key] : null;
    return Array.isArray(value) ? value : [];
  }

  // Returns the formatted value of one sub-field within a single grouped item
  getGroupFieldValue(group: any, subField: { key: string; label: string }): string {
    if (!group) return '-';
    const value = group[subField.key];
    if (value === null || value === undefined || value === '') return '-';
    return String(value);
  }

  showFullContent(title: string, content: string): void {
    this.modalTitle = title;
    this.modalContent = content;
    this.isModalVisible = true;
  }

  handleCancel(): void {
    this.isModalVisible = false;
  }
}
